import styled from 'styled-components';

export const Wrapper = styled.div`
  background-color: #e1e7ee;
`;

export const Container = styled.div(
  props => `
    width: 1200px;
    margin: 0 auto;
    padding-top: ${props.pt || ''};
    padding-bottom: ${props.pb || ''};
  `
);

export const LeftWrap = styled.div`
  width: 285px;
  float: left;
`;

export const RightWrap = styled.div`
  width: 895px;
  float: right;
`;

export const DisableClickOverlay = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 1000;
  top: 0px;
  left: 0px;
  opacity: 0;
`;

export const SnackBar = styled.div`
  position: fixed;
  bottom: -120px;
  background: #222222;
  color: #ffffff;
  box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.2);
  padding: 14px 16px;
  border-radius: 6px;
  z-index: 99;
  margin: 0 auto;
  left: 50%;
  width: 328px;
  text-align: center;
  transition: 0.4s ease-in-out 0.4s;
  bottom: 50px;
`;
